import i18n from "i18next";

export function truncate(str: string, length: number): string {
  return str.length > length ? `${str.substring(0, length - 3)}...` : str;
}

export function formatCurrency(str?: number): string {
  return (
    str?.toLocaleString(i18n.language, {
      style: "currency",
      currency: "EUR",
    }) || ""
  );
}

/**
 * Levenshtein distance > compaire two strings
 * return [0...1] > 1 strings are equal
 */
export function compareTwoStrings(f1, f2) {
  const first = f1.replace(/\s+/g, "");
  const second = f2.replace(/\s+/g, "");
  if (first === second) return 1;
  if (first.length < 2 || second.length < 2) return 0;
  const firstBigrams = new Map();
  for (let i = 0; i < first.length - 1; i++) {
    const bigram = first.substring(i, i + 2);
    const count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) + 1 : 1;
    firstBigrams.set(bigram, count);
  }
  let intersectionSize = 0;
  for (let i = 0; i < second.length - 1; i++) {
    const bigram = second.substring(i, i + 2);
    const count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) : 0;
    if (count > 0) {
      firstBigrams.set(bigram, count - 1);
      intersectionSize += 1;
    }
  }
  return (2.0 * intersectionSize) / (first.length + second.length - 2);
}
function areArgsValid(mainString, targetStrings) {
  if (typeof mainString !== "string") return false;
  if (!Array.isArray(targetStrings)) return false;
  if (!targetStrings.length) return false;
  if (targetStrings.find((s) => typeof s !== "string")) return false;
  return true;
}
export function findBestMatch(mainString, targetStrings) {
  if (!areArgsValid(mainString, targetStrings))
    throw new Error(
      "Bad arguments: First argument should be a string, second should be an array of strings"
    );
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ratings: any[] = [];
  let bestMatchIndex = 0;
  for (let i = 0; i < targetStrings.length; i++) {
    const currentTargetString = targetStrings[i];
    const currentRating = compareTwoStrings(mainString, currentTargetString);
    ratings.push({ target: currentTargetString, rating: currentRating });
    if (currentRating > ratings[bestMatchIndex].rating) {
      bestMatchIndex = i;
    }
  }
  const bestMatch = ratings[bestMatchIndex];
  return { ratings, bestMatch, bestMatchIndex };
}
